import { apiClient } from "@/api";

apiClient.init();
